import React, { Component } from 'react'
import { Check } from '@material-ui/icons';

import './style.scss'
class ProductInfoItem extends Component {

  render() {
    const { label, value, total } = this.props;
    return (
      <div className="product-info-item">
        <div className="label">
          <span>{label}</span>
          <Check />
        </div>
        <div className="value">
          {`R$${Number(value).toFixed(2)}(R$${Number(total).toFixed(2)})`}
        </div>
      </div>
    )
  }
}

export default ProductInfoItem